import logo from './logo.svg';
import './App.css';
import NavbarComponent from './Components/NavbarComponent';
import Footer from './Components/Footer';
import {HashRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Aboutus from './Components/Aboutus';
import Service from './Components/Service';
import Contactus from './Components/Contactus';
import Staffing from './Components/Staffing';
import Digital from './Components/Digital';
import Careers from './Components/Careers';
import Vacancy from './Components/Vacancy';
import Banking from './Components/Banking';
import Asset from './Components/Asset';
import CapitalMarket from './Components/CapitalMarket';
import Healthcare from './Components/Healthcare';
import Manufacturing from './Components/Manufacture';
import Transportation from './Components/Transportation';
import Facility from './Components/Facility';
import ScrollToTop from './Components/ScrollToTop';

function App() {           
  return (
    <>
    <ScrollToTop/>
    <NavbarComponent/>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/aboutus' element={<Aboutus/>}/>
      <Route path='/it-strategy-consulting' element={<Service/>}/>
      <Route path='/it-staffing-resource' element={<Staffing/>}/>
      <Route path='/digital-transformation' element={<Digital/>}/>
      <Route path='/contactus' element={<Contactus/>}/>
      <Route path='/cv' element={<Careers/>}/>
      <Route path='/vacancies' element={<Vacancy/>}/>
      <Route path='/industries/asset-management' element={<Asset/>}/>
      <Route path='/industries/banking' element={<Banking/>}/>
      <Route path='/industries/capitalmarkets' element={<CapitalMarket/>}/>
      <Route path='/industries/healthcare' element={<Healthcare/>}/>
      <Route path='/industries/manufacturing' element={<Manufacturing/>}/>
      <Route path='/industries/transportation' element={<Transportation/>}/>
      <Route path='/industries/facilities-management' element={<Facility/>}/>

    </Routes>
    <Footer/>
    </>
  );
}

export default App;
